import { render, staticRenderFns } from "./car-bomb-form.vue?vue&type=template&id=ded2c004&scoped=true&"
import script from "./car-bomb-form.vue?vue&type=script&lang=js&"
export * from "./car-bomb-form.vue?vue&type=script&lang=js&"
import style0 from "./car-bomb-form.vue?vue&type=style&index=0&id=ded2c004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded2c004",
  null
  
)

export default component.exports